import { Route } from '@angular/router';

export const truckDetailLayoutRoutes: Route[] = [];
